import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isMobileOnly, isTablet, isPortrait } from 'react-device-detect';

import './NumberFilters.scss';
import Calendar from '../Calendar/Calendar';
import NextDraws from '../NextDraws/NextDraws';
import Search from '../Search/Search';
import BetCodeSearch from 'src/components/BetCodeSearch/BetCodeSearch';
import Icon from '../../Icon/Icon';
import AppModeContext from '../../../containers/AppMode/AppMode.context';

class NumberFilters extends PureComponent {
  componentDidMount() {
    this.refreshInterval = setInterval(() => {
      this.props.loadNumberBettingTree(true);
    }, 120000);
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval);
  }

  resetSearch = () => {
    this.props.resetSearchResults();
  }

  getSearchResults = (value) => {
    this.props.getSearchResults({ q: value, product: 'lotto' });
  }

  handleCollapse = () => {
    const { RETAIL_MODE } = this.context;

    this.props.changeSidebarCollapsed({ sidebar: 'leftSideBar', isRetail: RETAIL_MODE, width: window.innerWidth });
  }

  render() {
    const { t, loadNumberBettingTree } = this.props;

    return (
      <div className="filter-container">
        <div className="number-filters__search">
          {
            !(isMobileOnly || (isTablet && isPortrait)) &&
            <button onClick={ this.handleCollapse } className="filter-container__btn--cross">
              <Icon icon="menuOpened" />
            </button>
          }
          <Search
            placeholder={ t('numbers.searchPlaceholder') }
            searchHelper={ t('numbers.searchHelper') }
            getSearchResults={ this.getSearchResults }
            handleReset={ this.resetSearch }
            minLength={ 2 }
          />
        </div>
        <BetCodeSearch productType={ 4 } />
        <NextDraws
          placeholder={ t('sideBar.nextDraws') }
          eventType="number"
        />
        <Calendar
          eventType="number"
          getTreeData={ loadNumberBettingTree }
          type="numbers"
        />
      </div>
    );
  }
}

NumberFilters.propTypes = {
  getSearchResults: PropTypes.func,
  resetSearchResults: PropTypes.func,
  t: PropTypes.func,
  loadNumberBettingTree: PropTypes.func,
  changeSidebarCollapsed: PropTypes.func
};

const mapDispatch = dispatch => ({
  getSearchResults: query => dispatch.events.getSearchResults(query),
  resetSearchResults: () => dispatch.events.resetSearchResults(),
  loadNumberBettingTree: value => dispatch.events.loadNumberBettingTree(value),
  changeSidebarCollapsed: (sidebar) => dispatch.content.changeSidebarCollapsed(sidebar)
});

NumberFilters.contextType = AppModeContext;

export default connect(null, mapDispatch)(withTranslation('common')(NumberFilters));
